import { render, staticRenderFns } from "./SubscriptionInfo.vue?vue&type=template&id=3ba52342&scoped=true"
import script from "./SubscriptionInfo.vue?vue&type=script&lang=ts"
export * from "./SubscriptionInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba52342",
  null
  
)

export default component.exports